import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Visibility from "@material-ui/icons/Visibility";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "components/layout/CommonStyles";
import DialogViewScholarshipRecess from "./DialogViewScholarshipRecess";
import DialogDeleteScholarshipRecess from "./DialogDeleteScholarshipRecess";

const ScholarshipsRecessesHistoryTableAction = ({ item, context, itemList }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const [open, setOpen] = useState(false);
  const [contextDialog, setContextDialog] = useState("");
  const [openDelete, setOpenDelete] = useState(false);

  const handleOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleOpenDialog = context => {
    setContextDialog(context);
    setOpen(true);
  };

  return (
    <React.Fragment>
      <React.Fragment>
        <Tooltip title={t("GENERAL.view")} aria-label="details" placement="top">
          <IconButton
            className={classes.iconsTableActions}
            onClick={() => handleOpenDialog("view", item.class)}
          >
            <Visibility />
          </IconButton>
        </Tooltip>

        {context !== "view" && (
          <Tooltip title={t("GENERAL.edit")} aria-label="edit" placement="top">
            <IconButton
              className={classes.iconsTableActions}
              onClick={() => handleOpenDialog("edit")}
            >
              <Edit />
            </IconButton>
          </Tooltip>
        )}

        {context !== "view" && (
          <Tooltip
            title={t("GENERAL.delete")}
            aria-label="delete"
            placement="top"
          >
            <IconButton
              className={classes.iconsTableActions}
              onClick={handleOpenDelete}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        )}
      </React.Fragment>

      {open && (
        <DialogViewScholarshipRecess
          open={open}
          setOpen={setOpen}
          context={contextDialog}
          item={item}
          itemList={itemList}
        />
      )}

      {openDelete && (
        <DialogDeleteScholarshipRecess
          open={openDelete}
          setOpen={setOpenDelete}
          context={contextDialog}
          item={item}
        />
      )}
    </React.Fragment>
  );
};

export default ScholarshipsRecessesHistoryTableAction;
